/** CoStar.Api.Lookup.PostalCodeGlobal.ShapeType */
export var ShapeType;
(function (ShapeType) {
    ShapeType[ShapeType["Unknown"] = 0] = "Unknown";
    ShapeType[ShapeType["UKPostalCodeArea"] = 11] = "UKPostalCodeArea";
    ShapeType[ShapeType["UKPostalCodeDistrict"] = 12] = "UKPostalCodeDistrict";
    ShapeType[ShapeType["PostalCode"] = 16] = "PostalCode";
    ShapeType[ShapeType["ForwardSortation"] = 18] = "ForwardSortation";
})(ShapeType || (ShapeType = {}));
